import {ApplicationRef, Component, NgZone, OnInit, ViewChild} from '@angular/core';
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {CadCartaocreditoPagSeguroComponent} from "../cad-cartaocredito/cad-cartaocredito-pag-seguro.component";
import {FormEnderecoComponent} from "../form-endereco/form-endereco.component";

import {PedidoLoja} from "../../objeto/PedidoLoja";
import {DadosCartao} from "../../objeto/DadosCartao";
import {FormUtils} from "../../objeto/FormUtils";
import {CadCartaoMercadopagoComponent} from "../cad-cartao-mercadopago/cad-cartao-mercadopago.component";
import {ICartaoCreditoGateway} from "../../objeto/ICartaoCreditoGateway";
import {CadCartaoCieloComponent} from "../cad-cartao-cielo/cad-cartao-cielo.component";
import {CadCartaoPagarmeComponent} from "../cad-cartao-pagarme/cad-cartao-pagarme.component";


@Component({
  selector: 'app-tela-cartao-de-credito',
  templateUrl: './tela-cartao-de-credito.component.html',
  styleUrls: ['./tela-cartao-de-credito.component.scss']
})
export class TelaCartaoDeCreditoComponent implements OnInit {
  msgErro: string;
  usarEnderecoDeEntrega = true;
  processandoDados = false;
  @ViewChild('dadosCartao', {static: false}) ctlDadosCartao: CadCartaocreditoPagSeguroComponent;
  @ViewChild('dadosCartaoMercadoPago', {static: false}) ctlDadosCartaoMercadoPago: CadCartaoMercadopagoComponent;
  @ViewChild('ctlDadosCartaoCielo', {static: false}) ctlDadosCartaoCielo: CadCartaoCieloComponent;
  @ViewChild('ctlDadosCartaoPagarme', {static: false}) ctlDadosCartaoPagarme: CadCartaoPagarmeComponent;
  @ViewChild('formEndereco', {static: false}) formEndereco: FormEnderecoComponent;

  window: DialogRef;
  pedido: PedidoLoja;
  obrigarEndereco: boolean;
  gateway: string
  numeroParcelasFixas: number;
  constructor(private app: ApplicationRef, private ngZone: NgZone) {
  }

  static abraComoPopup(dialogService: DialogService, isMobile: boolean,
                       pedido: PedidoLoja, pagamento: any, dadosCartao: DadosCartao): DialogRef {
    let altura: any = window.innerHeight - 100;
    if( isMobile ) {
      altura = '100%';
    }

    let largura: any = '100%';

    if( window.innerWidth > 600 ) {
      largura = 'calc(100% - ' + (window.innerWidth - 600) + 'px)';
    }

    let configJanela: any = {
      title: null,
      content: TelaCartaoDeCreditoComponent,
      minWidth: 250,
      width: largura
    };

    if( isMobile ) {
      configJanela.height = altura;
    } else {
      configJanela.maxHeight = altura;
    }

    const windowRef = dialogService.open(configJanela);

    const $divDialog = windowRef.dialog.location.nativeElement;

    if( $divDialog ) {
      const $divDialogContent = $divDialog.getElementsByClassName('k-dialog-content');

      if( $divDialogContent.length > 0 ) {
        $divDialogContent[0].classList.add('dialog-pagamento');
      }
    }

    const telaCartaoDeCreditoComponent: TelaCartaoDeCreditoComponent = windowRef.content.instance;
    telaCartaoDeCreditoComponent.inicialize(windowRef, pedido, pagamento, dadosCartao);

    return windowRef;
  }

  ngOnInit(): void {

  }

  obtenhaCtlDados(): ICartaoCreditoGateway{
    if(this.gatewayPagSeguro()) return this.ctlDadosCartao;
    if(this.gatewayMercadoPago()) return this.ctlDadosCartaoMercadoPago;
    if(this.gatewayPagCielo()) return this.ctlDadosCartaoCielo;
    if(this.gatewayPagarme()) return this.ctlDadosCartaoPagarme;
  }


  gatewayPagSeguro(){
    return this.gateway === 'pagseguro';
  }

  gatewayPagCielo(){
    return this.gateway === 'cielocheckout';
  }


  gatewayPagarme(){
    return this.gateway === 'pagarme';
  }

  gatewayMercadoPago(){
    return this.gateway === 'mercadopago';
  }

  inicialize(window: DialogRef, pedido: any, pagamento: any, dadosCartao: DadosCartao) {
    this.window = window;
    this.pedido = pedido;
    this.gateway  = pagamento.formaDePagamento.configMeioDePagamento.meioDePagamento;

    if( pedido.retirar || (pedido.entrega && pedido.entrega.ehRetirada()) ) {
      this.obrigarEndereco = true;
      this.usarEnderecoDeEntrega = false;
    }

    setTimeout( () => {
      if(this.gatewayPagSeguro())
        this.ctlDadosCartao.exibaCartao(dadosCartao)

      if(this.gatewayMercadoPago())
        this.ctlDadosCartaoMercadoPago.exibaCartao(dadosCartao)

      if(this.gatewayPagarme())
        this.ctlDadosCartaoPagarme.setParcelamento(pagamento.formaDePagamento.numeroParcelasFixas)
    }, 0)


  }

  fecheTela() {
    this.window.close(null);
  }

  alterouUsarEnderecoDeEntrega() {

  }

  obtenhaDadosSemDadosSensitivos() {
  }

  obtenhaEnderecoCobranca(){
    if(this.usarEnderecoDeEntrega)
      return this.pedido.entrega ? this.pedido.entrega.endereco : (this.pedido as any).endereco;

    return this.formEndereco ? this.formEndereco.obtenhaEndereco() :  null;

  }

  completeDadosCartao(dadosCartao: DadosCartao) {
    dadosCartao.usarEnderecoDeEntrega = this.usarEnderecoDeEntrega;

    if( this.formEndereco )
      dadosCartao.endereco = this.formEndereco.obtenhaEndereco();

  }

  getOffset(el: any) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  }


  salvarCartao() {
    let valido = true;
    const respValidadeCartao = this.obtenhaCtlDados().ehValido();

    if( !respValidadeCartao.valido ) {
      const $janela = document.querySelector('.k-content');
      FormUtils.foqueInvalido($janela, respValidadeCartao.controle)

      valido = false;
    }

    if( !this.usarEnderecoDeEntrega && this.formEndereco) {
      const respValidadeEndereco = this.formEndereco.ehValido();

      if( valido && !respValidadeEndereco.valido ) {
        const $janela = document.querySelector('.k-content');
        FormUtils.foqueInvalido($janela, respValidadeEndereco.controle)

        valido = false;
      }
    }

    if( !valido )    return;

    this.processandoDados = true;

    this.obtenhaCtlDados().crieTokenCartao(this.obtenhaEnderecoCobranca()).then( (dadosCartao: DadosCartao) => {
      this.ngZone.run( () => {
        // Callback para todas chamadas.
        this.processandoDados = false;
      });
      this.gerouTokenCartao(dadosCartao);
    }).catch( (erro) => {
      this.ngZone.run( () => {
        // Callback para todas chamadas.
        this.processandoDados = false;
        this.msgErro = erro;
      });
    })
  }

  gerouTokenCartao(dadosCartao: DadosCartao){
    this.completeDadosCartao(dadosCartao);
    this.window.close(dadosCartao);
    this.app.tick();
  }
}
